<script>
    import {onMount} from 'svelte';
    import rpcjs from 'rpcjs';
    const {title, goto} = rpcjs.props;
    title.set('Join Us');
    let textSection = 0;
    let image;
    /**
     */
    function onStart() {
        textSection = '1';
        image.style.left = '0vw';
    }
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(onStart, 10);
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            goto('/questions');
        }
        if (e.key == 'ArrowLeft') {
            goto('/ourTeam');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>

<section>
    <div class="main-div" role="presentation" on:click={()=> goto('/questions')}>
        <div class="image" bind:this={image}>
            <img
                src="../images/moat/d4yj0vq-eaab8c53-d33c-4faa-a87b-f7d28a271d791.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div
        class="textsection" style="opacity:{textSection}; transition-duration:1s;">
            <div class="exited">
                <p>EXCITED<br><span>ABOUT</span></p>
            </div>
            <div class="opus">
                <p>OPUS ?</p>
            </div>
            <div class="join">
                <p>JOIN US !</p>
            </div>
        </div>
    </div>
</section>

<style>
    p{
        margin: 0;
    }
    .main-div {
        position: relative;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        background-color: #010422;
    }
    .image {
        position: absolute;
        width: 56.708vw;
        height: 41.823vw;
        top: 14.87vh;
        left: -60vw;
        transition-duration: 0.8s;
    }
    .textsection{
        position: absolute;
        left: 63.438vw;
        top: 42.5vh;
    }
    .exited {
        color: white;
        font-family: "Montserrat";
        font-weight: 900;
        font-size: 3.125vw;
        text-align: end;
        line-height: 2vw;
        margin-right: 16vw;
    }
    .exited p span {
        font-size: 2.083vw;
    }
    .opus {
        font-family: "Montserrat";
        font-weight: 900;
        line-height: 6.5vw;
        font-size: 7.813vw;
        color: #ff007f;
    }
    .join{
        color: white;
        font-family: "Montserrat";
        font-weight: 900;
        font-size: 2.083vw;
        margin-left: 19.5vw;
    }
</style>
